import { GlobalState } from 'reducers';
import { getIsFeatureEnabledForUser } from 'selectors/features/getIsFeatureEnabledForUser';
import { Feature } from 'types/types';

export const getIsNewEndSessionEndpointEnabled = (state: GlobalState) =>
  getIsFeatureEnabledForUser(state, { feature: Feature.NewEndSessionEndpoint });
